export default __webpack_public_path__ + "static/media/ss2.1b7e0757.png";